import {ref} from "vue";
import {useDebounce} from "@vueuse/core";

export interface UseSearchDefaults {
    search?: string;
}

export const useSearch = (defaults?: UseSearchDefaults) => {

    const search = ref<string>(defaults?.search ?? '');
    const debouncedSearch = useDebounce<string>(search, 300);

    const setSearch = (query: string) => {
        search.value = query;
    }

    return {search, debouncedSearch, setSearch}
}
